$(document).ready(function(){
  $('.product-gallery-slider').css('visibility', 'visible');
  $('.product-gallery-thumbs').css('visibility', 'visible');

  $('.product-gallery-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-gallery-thumbs',
    responsive: [
      {
        breakpoint: 576,
        settings: {
          fade: false,
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.product-gallery-thumbs').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.product-gallery-slider',
    сenterMode: true,
    focusOnSelect: true,
  });

  initProductGalleryLightbox();

  $(document).on('click', '.portable-product-gallery__item', function () {
    const index = $(this).data('index');
    const $slide = $(`.product-gallery-slider .product-gallery-slider__slide[data-slick-index="${index}"]`)
      .not('.slick-cloned')
      .first();
    if (!$slide.length) return;
    if ($slide.find('img').length) {
      $slide.trigger('click');
    } else {
      $('.product-gallery-slider').slick('slickGoTo', index);
    }
  });

  // Change quantity
  $('.quantity__btn').click(function(event) {
    let n = parseInt($(this).parent().find('.quantity__value').val());
    if($(this).hasClass('btn_minus')){
      n = n - 1;
      if(n < 1){n = 1;}
    }else{
      n = n + 1;
    }
    $(this).parent().find('.quantity__value').val(n);
    return false;
  });
});

function initProductGalleryLightbox() {
  const $slider = $('.product-gallery-slider');
  if (!$slider.length || typeof $.fn.slickLightbox !== 'function') return;
  if ($slider[0].slickLightbox) return;

  $slider.slickLightbox({
    // Only image slides — skip video slides so they don't create blank slides
    itemSelector: '.product-gallery-slider__slide:has(img)',
    src: function(element) {
      const img = $(element).find('img');
      if (img.length) {
        return img.attr('src').replace(/width=\d+/, 'width=1600');
      }
      return '';
    },
    background: 'rgba(0, 0, 0, 0.85)',
    closeOnEscape: true,
    closeOnBackdropClick: true,
    navigateByKeyboard: true,
    slick: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: false,
      infinite: true,
      swipe: true
    }
  });
}

$(window).on('load', function () {
  initProductGalleryLightbox();
});

// Variant selector redirect
$(document).ready(function(){
  $("#select-variants").change(function(){
    window.location.href = $(this).val();
  });
});

$(document).ready(function () {
  $(document).on('click', '[data-pads-trigger]', function (e) {
    e.preventDefault();
    var $root = $(this).closest('[data-pads-dropdown]');
    var willOpen = !$root.hasClass('is-open');
    $root.toggleClass('is-open', willOpen);
    $root.find('[data-pads-list]').prop('hidden', !willOpen);
    $(this).attr('aria-expanded', willOpen ? 'true' : 'false');
  });
  $(document).on('click', function (e) {
    if (!$(e.target).closest('[data-pads-dropdown]').length) {
      $('[data-pads-dropdown].is-open').each(function () {
        var $root = $(this);
        $root.removeClass('is-open');
        $root.find('[data-pads-list]').prop('hidden', true);
        $root.find('[data-pads-trigger]').attr('aria-expanded', 'false');
      });
    }
  });
});
